import { ImageListInputs } from './ImageList';

export const imageListTransformer = (node: any): ImageListInputs => {
    return {
        image:
            node.relationships?.field_li_image.length > 0 &&
            node.relationships.field_li_image[0],
        learnMoreLink: node.field_learn_more_link?.uri,
        title: node.field_li_paragraph_title,
        text: node.field_li_paragraph_text,
        imageAlt: node.field_li_image?.alt,
    };
};
